/**
 * The minute fields on the Desktop settings section, and the range each
 * accepts. The shell checks the same ranges and has the final say; checking
 * here too is what lets the form say what is wrong before anything is sent.
 */

import type { DesktopPomodoroSettings } from "../bridge";

export type MinuteField = keyof DesktopPomodoroSettings;

export const FIELD_BOUNDS: Record<MinuteField, { min: number; max: number }> = {
  focusMinutes: { min: 1, max: 120 },
  breakMinutes: { min: 1, max: 60 },
  longBreakMinutes: { min: 1, max: 60 },
  longBreakEvery: { min: 1, max: 12 },
  meetingGraceMinutes: { min: 0, max: 30 },
  idleMinutes: { min: 1, max: 120 },
  preMeetingBufferMinutes: { min: 0, max: 30 },
};

export const TIMER_FIELDS: readonly MinuteField[] = [
  "focusMinutes",
  "breakMinutes",
  "longBreakMinutes",
  "longBreakEvery",
];

export const PRESENCE_FIELDS: readonly MinuteField[] = [
  "meetingGraceMinutes",
  "idleMinutes",
  "preMeetingBufferMinutes",
];

/** The whole number typed, or null when the text is not one within range. */
export function parseMinutes(field: MinuteField, text: string): number | null {
  if (!/^\d+$/.test(text.trim())) return null;
  const value = Number(text.trim());
  const { min, max } = FIELD_BOUNDS[field];
  return value >= min && value <= max ? value : null;
}
